export enum PostType {
  text = 0,
  file = 1,
  link = 2,
}
